exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".InviteUsers .checkbox_custom label_switch{margin:5px 0 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/invite-users/invite-users.scss
// module id = 1368
// module chunks = 0